import styled from 'styled-components';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@monavate/ui-core';
import { clientViewService } from '@/helpers/clientViewService';
import { useTheme } from 'styled-components';

const StickyPlaceholder = styled.div`
    position: sticky;
    top: 102px;

    height: 0;

    width: 100%;
    z-index: 8;
`;

const Container = styled.div`
    position: absolute;
    top: 4px;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Separator = styled.div`
    border-top: 1px solid ${(props) => props.theme['Status/warning/overlay']};
    width: 100%;
    height: 1px;
    background: ${(props) => props.theme['Status/warning/overlay']};
`;

const TextContainer = styled.div`
    background: ${(props) => props.theme['Status/warning/overlay']};
    padding: 1px 4px 2px 20px;
    flex-shrink: 0;
    flex-grow: 0;
    color: ${(props) => props.theme['Content/overlay']};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

const NameContainer = styled.span`
    font-weight: 600;
`;

const ViewAsClientBlock = () => {
    const { isAuthenticated } = useAuth0();
    const theme = useTheme();
    const isViewAsClient = clientViewService.isViewAsClient();
    const selectedClient = clientViewService.getSelectedClientName();

    const backToNormalView = () => {
        window.applyAdminView();
        setTimeout(() => {
            window.location.pathname = '/';
        }, 1);
    };

    return isAuthenticated && isViewAsClient ? (
        <StickyPlaceholder>
            <Container>
                <Separator />
                <TextContainer>
                    You are viewing as <NameContainer>{selectedClient}</NameContainer>
                    <Button
                        viewType={'tertiary'}
                        style={{
                            color: theme['Content/overlay'],
                            padding: '4px 16px',
                            height: 'auto',
                            marginLeft: '8px',
                        }}
                        tertiaryHoverBg={'#c26735'}
                        handleClick={backToNormalView}
                    >
                        Exit
                    </Button>
                </TextContainer>
            </Container>
        </StickyPlaceholder>
    ) : null;
};

export default ViewAsClientBlock;
